var _defs, _line, _line2, _line3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconEnlargeMagnifyingPlusLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .zoominline {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "zoominline",
    x1: 34.36,
    y1: 34.36,
    x2: 45.81,
    y2: 45.81
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "zoominline",
    x1: 13.09,
    y1: 21.88,
    x2: 30.67,
    y2: 21.88
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "zoominline",
    x1: 21.88,
    y1: 30.67,
    x2: 21.88,
    y2: 13.09
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "zoominline",
    cx: 21.88,
    cy: 21.88,
    r: 17.69
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconEnlargeMagnifyingPlusLine);
export default __webpack_public_path__ + "static/media/cloud_icon_enlarge_magnifying_plus_line.933224c52d180fd51c63177feccd50c4.svg";
export { ForwardRef as ReactComponent };